import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'SortTaskList'
})

export class TaskListFilter implements PipeTransform {
    transform(tasklist: any[], queueCd: String): any {
        var sortedArr = [];
        if (queueCd && tasklist && queueCd !== undefined && queueCd !== '') {
            for (var i = 0; i < tasklist.length; i++) {
                if (tasklist[i].workQueue == queueCd)
                    sortedArr.push(tasklist[i]);
            }
        } else {
            sortedArr = tasklist;
        }
        return sortedArr;
    }
} 